import React, { useState, useEffect } from "react";
import MstService from "../../services/mst.service";
import requestAndErrorHandler from "../../services/responseAndErrorHandler";
import { Button } from "react-bootstrap";
import i18n from "../../i18n/i18n";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
const InvoiceByLink = () => {
  const { t } = useTranslation();
  const src =
    "data:image/png;base64,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";

  let ref_no = new URLSearchParams(window.location.search).get("ref_no");
  let id = new URLSearchParams(window.location.search).get("id");

  const [item, setItem] = useState("");
  const [type, setType] = useState("");
  const [otp, setOtp] = useState("");
  const [pinSection, setPinSection] = useState(false);
  const [otpSection, setOtpSection] = useState(false);
  const [pin, setPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [login_phone, setLogin_phone] = useState("");
  const [updateMobile, setUpdateMobile] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [showResendOtp, setShowResendOtp] = useState(false);

  const [showNewRegistration, setShowNewRegistration] = useState(true);

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedLanguage(selectedValue);
    i18n.changeLanguage(selectedValue);
  };

  useEffect(() => {
    MstService.getRetailerInvoiceByLink({
      ref_no: ref_no,
      id: id,
    })
      .then((response) => {
        setItem(response?.data?.data);
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  }, []);

  const checkUserExist = () => {
    const { mobile_no } = item;

    MstService.SignupOTPVerification({ login_phone: mobile_no })
      .then((response) => {
        if (response?.data?.errorCode === 0) {
          setOtpSection(true);
          const successToast = toast.success(
            t("invoiceByLink.otpSendSuccessfully"),
            {
              position: "bottom-left",
              autoClose: false,
            }
          );
          setShowResendOtp(true);
          setShowNewRegistration(false);
          setTimeout(() => {
            toast.dismiss(successToast);
          }, 2000);
        } else {
          setOtpSection(false);
          const successToast = toast.success(
            t("invoiceByLink.youAreAlreadyRegWithUs"),
            { position: "bottom-left", autoClose: false }
          );
          setTimeout(() => {
            toast.dismiss(successToast);
          }, 2000);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  const CreateRetailerPin = () => {
    const { mobile_no } = item;
    MstService.createRetailerPin({ mobile_no: mobile_no, pin: pin })
      .then((response) => {
        if (response?.data?.errorCode === 0) {
          CreateRetailer();
        } else {
          const successToast = toast.success(`${response?.data?.message}`, {
            position: "bottom-left",
            autoClose: false,
          });
          setTimeout(() => {
            toast.dismiss(successToast);
          }, 2000);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  const ValidateOTP = () => {
    const { mobile_no } = item;
    MstService.OTPVerficationSignUp({
      login_phone: mobile_no,
      otp_or_pin: otp,
      type: "otp",
    })
      .then((response) => {
        if (response?.data?.errorCode === 0) {
          setPinSection(true);
          setShowResendOtp(false);
          setShowNewRegistration(false);
        } else {
          setPinSection(false);
        }
        const successToast = toast.success(`${response?.data?.message}`, {
          position: "bottom-left",
          autoClose: false,
        });
        setTimeout(() => {
          toast.dismiss(successToast);
        }, 2000);
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  const resetForm = (value) => {
    setType(value);
    setOtpSection(false);
    setOtp("");
    setPinSection(false);
    setPin("");
    setConfirmPin("");
  };

  const ChangeType = (value) => {
    resetForm(value);
    if (value === "NEW") {
      checkUserExist();
    } else {
      resetForm();
      setType("UPDATE");
    }
  };

  const CreateRetailer = () => {
    const { mobile_no } = item;
    MstService.retailerMasterEntry({
      ret_mobile: mobile_no,
      ret_name: item?.invoiceDataList[0]?.party_name,
      agency_name: item?.invoiceDataList[0]?.agent_name,
    })
      .then((response) => {
        if (response?.data?.errorCode === 201) {
          resetForm();
          window.open(
            "https://play.google.com/store/search?q=fuseit&c=apps&hl=en-IN",
            "_blank"
          );
        } else {
          const successToast = toast.success(`${response?.data?.message}`, {
            position: "bottom-left",
            autoClose: false,
          });
          setTimeout(() => {
            toast.dismiss(successToast);
          }, 2000);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  const UpdateRetailerMobile = () => {
    const { mobile_no } = item;
    MstService.retailerUpdateMobileReq({
      ret_mobile: mobile_no,
      update_mobile: updateMobile,
    })
      .then((response) => {
        resetForm();
        const successToast = toast.success(`${response?.data?.message}`, {
          position: "bottom-left",
          autoClose: false,
        });
        setTimeout(() => {
          toast.dismiss(successToast);
        }, 2000);
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  return (
    <>
      {" "}
      {item && item !== "" ? (
        <>
          <div className="col-3 ">
            <label>{t("invoiceByLink.selectLanguage")}</label>
            <select
              id="languageSelect"
              className="form-control"
              value={selectedLanguage}
              onChange={handleChange}
            >
              <option value="en">English</option>
              <option value="hi">हिंदी</option>
            </select>
          </div>
          <h1
            className="invoiceHeader mt-2"
            style={{ backgroundColor: "var(--themeBlue-color)" }}
          >
            {t("invoiceByLink.paymentReceipt")}
          </h1>
          <div style={{ marginTop: 40, overflow: "auto" }}>
            <table
              style={{
                fontFamily: "serif",
                borderCollapse: "collapse",
                width: "100%",
              }}
            >
              <tr
                className="tableHeader"
                style={{ backgroundColor: "var(--themeBlue-color)" }}
              >
                <th className="table_th">
                  <h4>{t("invoiceByLink.date")}</h4>
                </th>
                <th className="table_th">
                  <h4>{t("invoiceByLink.receiptNo")} </h4>
                </th>
                <th className="table_th">
                  <h4>{t("invoiceByLink.refInvoiceNo")} </h4>
                </th>
                <th className="table_th">
                  <h4> {t("invoiceByLink.partyName")} </h4>
                </th>
                <th className="table_th">
                  <h4>{t("invoiceByLink.paidAmount")}</h4>
                </th>
                <th className="table_th">
                  <h4>{t("invoiceByLink.paymentMode")}</h4>
                </th>
                <th className="table_th">
                  <h4>{t("invoiceByLink.chequeNumberOnlineRefNumberIfAny")}</h4>
                </th>
              </tr>
              <tr className="tableRow">
                <td className="table_th">
                  {item?.invoiceDataList[0]?.format_date}
                </td>
                <td className="table_th">
                  {new Date().getDay()}${item?.invoiceDataList[0]?.ref_no}
                </td>
                <td className="table_th">{item?.invoiceDataList[0]?.ref_no}</td>
                <td className="table_th">
                  {item?.invoiceDataList[0]?.party_name}
                </td>
                <td className="table_th">
                  {item?.invoiceDataList[0]?.payment}
                </td>
                <td className="table_th">
                  {item?.invoiceDataList[0]?.payment_type}
                </td>
                <td className="table_th">
                  {item?.invoiceDataList[0]?.payment_ref
                    ? item?.invoiceDataList[0]?.payment_ref
                    : "____"}
                </td>
              </tr>
            </table>
          </div>
          <div style={{ marginTop: 40, marginRight: 2 }}>
            <h4 style={{ textAlign: "right" }}>
              <div style={{ fontWeight: "bold" }}>
                {" "}
                {t("invoiceByLink.partyName")} :
              </div>
              <div>{item?.invoiceDataList[0]?.party_name}</div>
            </h4>
            <h4 style={{ textAlign: "right" }}>
              <div style={{ fontWeight: "bold" }}>
                {t("invoiceByLink.agencyName")} :
              </div>
              <div>{item?.invoiceDataList[0]?.agent_name}</div>
            </h4>
          </div>
          <div
            className="registerLink"
            style={{ backgroundColor: "var(--themeBlue-color)" }}
          >
            <h4>{t("invoiceByLink.sufftjnaartaayrof")}</h4>
          </div>
          <div>
            {showNewRegistration && (
              <Button
                className="invoiceButton mt-3"
                onClick={() => ChangeType("NEW")}
              >
                {t("invoiceByLink.newRegistration")}
              </Button>
            )}

            {showResendOtp && (
              <Button
                className="invoiceButton mt-3"
                onClick={() => ChangeType("NEW")}
              >
                {t("invoiceByLink.reSendOtp")}
              </Button>
            )}
          </div>
          {/*   <div style={{ textAlign: "center", fontWeight: 700, padding: 15 }}>
            <a
              href="#"
              onClick={() =>
                ChangeType("UPDATE", item?.invoiceDataList[0]?.mobile)
              }
            >
              Update Mobile
            </a>
          </div> */}

          <>
            {otpSection === true && pinSection === false ? (
              <div class="card">
                <div class="card-body">
                  <div className="otpdiv">
                    <h1>{t("invoiceByLink.otpSentYourRegistredMobileNo")}</h1>
                    <input
                      className="otpinput"
                      type="number"
                      onChange={(e) => setOtp(e.target.value)}
                      placeholder={t("invoiceByLink.enterOTP")}
                    ></input>
                  </div>

                  {otp.length > 5 && otp.length === 6 ? (
                    <Button
                      onClick={() => ValidateOTP()}
                      className="invoiceButton"
                    >
                      Validate & Confirm
                    </Button>
                  ) : null}
                </div>
              </div>
            ) : null}
            {pinSection === true && type === "NEW" ? (
              <div class="card">
                <div class="card-body">
                  <div className="otpdiv">
                    <h1>{t("invoiceByLink.genrateYourPin")}</h1>
                    <input
                      onChange={(e) => setPin(e.target.value)}
                      className="otpinput"
                      type="number"
                      placeholder={t("invoiceByLink.enter4DigitNewPin")}
                    ></input>
                    {pin.length === 4 ? (
                      <input
                        className="otpinput mt-3"
                        onChange={(e) => setConfirmPin(e.target.value)}
                        type="password"
                        placeholder={t("invoiceByLink.enter4DigitConfirmPin")}
                      ></input>
                    ) : null}
                  </div>
                  {type === "NEW" && pin === confirmPin && pin.length === 4 ? (
                    <Button
                      className="invoiceButton"
                      onClick={() => CreateRetailerPin()}
                    >
                      {t("invoiceByLink.setPin")}
                    </Button>
                  ) : confirmPin.length === 4 ? (
                    <p className="errormsg">
                      {t("invoiceByLink.pinAndConfirmpinMismatch")}
                    </p>
                  ) : null}
                </div>
              </div>
            ) : null}
          </>
          {type === "UPDATE" ? (
            <div className="updatesection">
              <div class="card">
                <div class="card-body">
                  <p>{t("invoiceByLink.pctyafuymnosro")} </p>
                  <input
                    onChange={(e) => setUpdateMobile(e.target.value)}
                    className="otpinput"
                    type="number"
                    placeholder={t("invoiceByLink.enterNewMobileNo")}
                  ></input>
                  {updateMobile === login_phone && updateMobile !== "" ? (
                    <p>{t("invoiceByLink.tnarpctn")}</p>
                  ) : updateMobile.length === 10 ? (
                    <Button
                      className="invoiceButton"
                      onClick={() => UpdateRetailerMobile()}
                    >
                      {t("invoiceByLink.sendRequestToAgency")}
                    </Button>
                  ) : null}
                </div>
              </div>
            </div>
          ) : null}
          <div style={{ bottom: 20, width: "100%", textAlign: "center" }}>
            <p style={{ marginTop: 10 }}>
              <span style={{ fontSize: 14.5, lineHeight: 1.6 }}>
                {t("invoiceByLink.powerdBy")}
              </span>
              <img
                width="100px"
                height="30px"
                src={src}
                id="flogo"
                style={{ verticalAlign: "middle" }}
              ></img>
            </p>
          </div>
          <p
            style={{
              bottom: 0,
              width: "100%",
              textAlign: "center",
            }}
          >
            {t("invoiceByLink.thisIsComputerGenertedReceipt")}
          </p>
        </>
      ) : null}
    </>
  );
};
export default InvoiceByLink;
